export default "__VITE_ASSET__228ebce1__"